/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CustomerDto } from '../../models/customer-dto';

export interface ApiCustomerGet$Plain$Params {
}

export function apiCustomerGet$Plain(http: HttpClient, rootUrl: string, params?: ApiCustomerGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CustomerDto>>> {
  const rb = new RequestBuilder(rootUrl, apiCustomerGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CustomerDto>>;
    })
  );
}

apiCustomerGet$Plain.PATH = '/api/Customer';
